import React from 'react';


// before you switch this, remember there are aria-labels with celsius hardcoded.
const TemperatureRenderer = ({ temperature, maxDecimalPoints = 2 }) => {
    let calculatedTemperature = temperature;

    // calculatedTemperature = ((temperature * (9/5))+32).toFixed(maxDecimalPoints); //farenheit

    return (
        <span>{calculatedTemperature} <sup>°</sup>C</span>
    );
};

export default TemperatureRenderer;